export default "__VITE_ASSET__8793170a__"